import React, { useCallback, useMemo, useState } from 'react';

import { MenuItem, Select, makeStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import cx from 'classnames';
import { debounce } from 'lodash';
import moment from 'moment';

import { ReactComponent as FilterIcon } from 'pages/Teachers/ClassroomInsights/assets/filter-icon.svg';
import CoachingContent from 'pages/Teachers/Home/components/CoachingContent';
import ColumnContainer from 'pages/Teachers/Home/components/ColumnContainer';
import DashboardHeader from 'pages/Teachers/Home/components/DashboardHeader';
import PriorityGradingList from 'pages/Teachers/Home/components/PriorityGradingList';
import StartEmptyBox from 'pages/Teachers/Home/components/StartEmptyBox';
import TommorowFocusContent from 'pages/Teachers/Home/components/TommorowFocusContent';
import { useNavbar } from 'pages/Teachers/shared';

import { ReactComponent as CoachingIcon } from './assets/coaching-icon.svg';
import { ReactComponent as CoachingSmallIcon } from './assets/coaching-small-icon.svg';
import { ReactComponent as FocusIcon } from './assets/focus-icon.svg';
import { ReactComponent as FocusSmallIcon } from './assets/focus-small-icon.svg';
import { ReactComponent as GradingIcon } from './assets/grading-icon.svg';
import { ReactComponent as HomeIcon } from './assets/home-icon.svg';
import { ReactComponent as SearchIcon } from './assets/search-icon.svg';
import { ReactComponent as StartIcon } from './assets/start-icon.svg';
import styles from './styles.module.scss';

const sections = [
  { value: 'section1', label: 'Section 1', key: 'section1' },
  { value: 'section2', label: 'Section 2', key: 'section2' }
];

const results1 = [
  {
    name: 'Test Assignment Create 27/02 (check grade) - 3 pages',
    id: '1',
    section: 'Section 1',
    due_date: '2026-03-07T13:00:55Z'
  },
  {
    name: 'Unit 3 - Lesson 1 - Exit Ticket (Cool Down) Test Insights',
    id: '2',
    section: 'Section 1Section 1Section 1Section 1',
    due_date: '2026-10-12T08:00:55Z'
  },
  {
    name: 'Assignment 3',
    id: '3',
    section: 'VVSD - Test Section 1',
    due_date: '2024-09-20T00:00:00Z'
  },
  {
    name: 'Assignment 4',
    id: '4',
    section: 'Section 2',
    due_date: '2024-09-25T00:00:00Z'
  },
  {
    name: 'Assignment 5',
    id: '5',
    section: 'Section 1',
    due_date: '2024-09-30T00:00:00Z'
  },
  {
    name: 'Assignment 6',
    id: '6',
    section: 'Section 3',
    due_date: '2024-10-05T00:00:00Z'
  },
  {
    name: 'Assignment 7',
    id: '7',
    section: 'Section 2',
    due_date: '2024-10-10T00:00:00Z'
  },
  {
    name: 'Test Assignment Create 27/02 (check grade) - 3 pages',
    id: '1',
    section: 'Section 1',
    due_date: '2026-03-07T13:00:55Z'
  },
  {
    name: 'Unit 3 - Lesson 1 - Exit Ticket (Cool Down) Test Insights',
    id: '2',
    section: 'Section 1Section 1Section 1Section 1',
    due_date: '2026-10-12T08:00:55Z'
  },
  {
    name: 'Assignment 3',
    id: '3',
    section: 'VVSD - Test Section 1',
    due_date: '2024-09-20T00:00:00Z'
  },
  {
    name: 'Assignment 4',
    id: '4',
    section: 'Section 2',
    due_date: '2024-09-25T00:00:00Z'
  },
  {
    name: 'Assignment 5',
    id: '5',
    section: 'Section 1',
    due_date: '2024-09-30T00:00:00Z'
  },
  {
    name: 'Assignment 6',
    id: '6',
    section: 'Section 3',
    due_date: '2024-10-05T00:00:00Z'
  },
  {
    name: 'Assignment 7',
    id: '7',
    section: 'Section 2',
    due_date: '2024-10-10T00:00:00Z'
  }
];

const useStyles = makeStyles((theme) => ({
  selectRoot: {
    height: '36px',
    backgroundColor: '#F8F7FF',
    borderRadius: '10px',
    border: '1.5px solid #E0D9F7',
    padding: '4px 12px',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      borderColor: '#D1C4E9',
      backgroundColor: '#F3F0FF'
    },
    '&:before, &:after': {
      display: 'none'
    }
  },
  selectIcon: {
    color: '#6A61A1',
    right: '4px'
  },
  inputText: {
    color: '#6A61A1',
    fontSize: '14px',
    fontWeight: 400,
    fontFamily: 'inherit',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  placeholder: {
    color: '#7B74AB',
    opacity: 0.8
  }
}));

const Home = () => {
  const [isLogged, setIsLogged] = useState(false);
  const [sectionValue, setSectionValue] = useState('placeholder');
  const [openSection, setOpenSection] = useState(false);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [query, setQuery] = useState('');

  const [open, setOpen] = useState(false);
  const [results, setResults] = useState(results1);

  const classes = useStyles();

  const runSearch = useMemo(
    () =>
      debounce((value) => {
        const v = value.toLowerCase();
        setResults(
          results1.filter((s) => s.name.toLocaleLowerCase().includes(v))
        );
        setOpen(true);
      }, 300),
    []
  );
  const onChange = useCallback(
    (e) => {
      const value = e.target.value;
      setQuery(value);
      runSearch(value);
    },
    [runSearch]
  );

  const handleSelect = (student) => {
    setQuery('');
    setResults([]);
    setOpen(false);
  };

  const navConfig = useMemo(
    () => ({
      title: (
        <div className={styles.navHeaderGroup}>
          <div className={styles.navTitleRow}>
            <HomeIcon className={styles.homeIcon} />
            <span>Home</span>
          </div>
          <div className={styles.navSubtext}>
            Prioritize grading, review patterns, and plan tomorrow's next steps.
          </div>
        </div>
      ),
      RightSubheader: (
        <div className={styles.searchWrapper}>
          <div className={styles.searchInput}>
            <IconButton
              className={styles.filterBtn}
              onClick={() => {
                setFiltersOpen((open) => !open);
                setOpen(false);
              }}
            >
              <FilterIcon />
            </IconButton>

            <input
              type="text"
              placeholder="Search Assignments here..."
              value={query}
              onChange={onChange}
            />

            <SearchIcon />
          </div>

          {open && (
            <div className={styles.results}>
              {results.length === 0 && (
                <div className={cx(styles.result, styles.empty)}>
                  No assignments found
                </div>
              )}
              {results.map((assignment, index) => (
                <div
                  key={index}
                  className={styles.result}
                  onClick={() => handleSelect(assignment)}
                >
                  <Tooltip title={assignment.name}>
                    <div className={styles.nameSection}>{assignment.name}</div>
                  </Tooltip>
                  <Tooltip title={assignment.section}>
                    <div className={styles.sectionBox}>
                      {assignment.section}
                    </div>
                  </Tooltip>
                  <div className={styles.dueDate}>
                    {moment(assignment.due_date).format('MMM D, YYYY')}
                  </div>
                </div>
              ))}
            </div>
          )}

          {filtersOpen && (
            <div className={styles.filters}>
              <Select
                open={openSection}
                onClose={() => setOpenSection(false)}
                onOpen={() => setOpenSection(true)}
                value={sectionValue}
                onChange={(level) => {
                  setSectionValue(level.target.value);
                }}
                IconComponent={ExpandMoreIcon}
                className={classes.selectRoot}
                classes={{
                  select: classes.inputText,
                  icon: classes.selectIcon
                }}
              >
                <MenuItem value="placeholder" disabled>
                  Assignment Section
                </MenuItem>
                {sections.map(({ value, label, key }) => {
                  return (
                    <MenuItem
                      key={key}
                      value={value}
                      className={classes.menuItem}
                    >
                      {label}
                    </MenuItem>
                  );
                })}
              </Select>
            </div>
          )}
        </div>
      )
    }),
    [
      onChange,
      classes.inputText,
      classes.selectIcon,
      classes.selectRoot,
      filtersOpen,
      openSection,
      query,
      sectionValue,
      classes.menuItem,
      open,
      results
    ]
  );

  useNavbar(navConfig);

  return (
    <div className={styles.container}>
      <DashboardHeader setIsLogged={setIsLogged} />

      <div className={styles.grid}>
        {/* COLUMN 1: Priority Grading */}
        <ColumnContainer
          title="START HERE:"
          titleDescription=" Priority Grading"
          smallIcon={<StartIcon />}
          headerRight={
            isLogged ? <span className={styles.countBadge}>14</span> : null
          }
        >
          {isLogged ? (
            <PriorityGradingList />
          ) : (
            <StartEmptyBox
              stepNumber="STEP 1"
              description="Launch your first student mission to see priority grading appear here."
              icon={<GradingIcon />}
              actionLabel="CREATE ASSIGNMENT"
            />
          )}
        </ColumnContainer>

        {/* COLUMN 2: Tomorrow's Focus */}
        <ColumnContainer
          title=""
          titleDescription="Tomorrow's Focus"
          smallIcon={<FocusSmallIcon />}
        >
          {isLogged ? (
            <TommorowFocusContent />
          ) : (
            <StartEmptyBox
              stepNumber="STEP 2"
              description="Reflect on today's data and set goals for your next lesson."
              icon={<FocusIcon />}
            />
          )}
        </ColumnContainer>

        {/* COLUMN 3: PLC / Coaching */}
        <ColumnContainer
          title=""
          titleDescription="Discuss in PLC / Coaching"
          smallIcon={<CoachingSmallIcon />}
        >
          {isLogged ? (
            <CoachingContent />
          ) : (
            <StartEmptyBox
              stepNumber="STEP 3"
              description="Once students submit, we will group them by misconception for your next team meeting."
              icon={<CoachingIcon />}
            />
          )}
        </ColumnContainer>
      </div>
    </div>
  );
};

export default Home;
